export enum SpecialFolderEnum {
  QuickShare = 'FTA27E720F2F2BD4718893095FE4354A4F6',
}
